<script setup lang="ts">
</script>

<template>
  <main>
    <h1 class="page-title">인증키 관리</h1>
    <p class="placeholder-message">준비 중입니다.</p>
  </main>
</template>
